/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Stock_Check_TitleInputs */

const vi_await_stock_check_title = /** @type {(inputs: Await_Stock_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra tồn kho`)
};

/**

* @param {Await_Stock_Check_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_stock_check_title = /** @type {((inputs?: Await_Stock_Check_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Stock_Check_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_stock_check_title(inputs)
});